import React, { useRef, useEffect, useContext } from 'react';
import PropTypes from 'prop-types';
import injectSheet from 'react-jss';

import useNebula from 'hooks/useNebula';
import AppContext from '../AppContext';

const styles = () => ({
  viz: {

  },
});

const Bar = ({
  classes,
  object,
}) => {
  const qlikApp = useContext(AppContext);

  const nebula = useNebula(qlikApp);
  const barRef = useRef();
  const barVizRef = useRef();

  useEffect(async () => {
    if (!nebula) return;
    barVizRef.current = await nebula.render({
      element: barRef.current,
      id: object,
    });
  }, [nebula]);

  return (
    <>
      <div id={object} className={classes.viz} ref={barRef} style={{ height: 450 }} />
    </>
  );
};

Bar.propTypes = {
  classes: PropTypes.object.isRequired,
  object: PropTypes.string.isRequired,
};

export default injectSheet(styles)(Bar);
